import { render, staticRenderFns } from "./OverallPage.vue?vue&type=template&id=080b6fed"
import script from "./OverallPage.vue?vue&type=script&lang=js"
export * from "./OverallPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports